var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburgerClose = function SvgHamburgerClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 89 89",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.303 45.45 75.222 18.48a2.691 2.691 0 0 0-1.927-4.48 2.683 2.683 0 0 0-1.865.683L44.5 41.642 17.57 14.684a2.683 2.683 0 0 0-3.688.104 2.69 2.69 0 0 0-.104 3.694l26.92 26.968-26.92 26.967A2.69 2.69 0 0 0 15.68 77a2.63 2.63 0 0 0 1.89-.785L44.5 49.257l26.93 26.958a2.632 2.632 0 0 0 1.89.785 2.683 2.683 0 0 0 2.475-1.657 2.693 2.693 0 0 0-.573-2.926L48.302 45.45Z",
    fill: "currentColor"
  })));
};
export { SvgHamburgerClose as ReactComponent };
export default __webpack_public_path__ + "b5720e3161ff51e8c9b7230c510b94cf.svg";